export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/onenews-favicon.ico"},{"rel":"preload","as":"script","href":"https://launchpad.privacymanager.io/latest/launchpad.bundle.js"}],"style":[],"script":[{"innerHTML":"\n(function(w,d,n){\n    function readCookie(name){\n        var parts=d.cookie.split(/;\\s*/);\n        for(var i=0;i<parts.length;i++){\n            var eq=parts[i].indexOf('=');\n            if(eq!==-1&&parts[i].slice(0,eq)===name){\n                try{return decodeURIComponent(parts[i].slice(eq+1));}catch{return null;}\n            }\n        }\n        return null;\n    }\n    function parsePrior(raw){\n        if(raw===null)return null;\n        try{\n            var value=JSON.parse(raw);\n            return value&&value.state==='deny'&&typeof value.at==='number'&&Number.isFinite(value.at)?value:null;\n        }catch{return null;}\n    }\n    var storedPrior=null;\n    try{storedPrior=parsePrior(w.localStorage.getItem('duplex.consent'));}catch{}\n    storedPrior=storedPrior||parsePrior(readCookie('duplex.consent'));\n    var priorDenies=storedPrior!==null&&Date.now()-storedPrior.at<31536000000;\n    var usp=readCookie('us_privacy');\n    var uspDenies=usp!==null&&usp.charAt(2).toUpperCase()==='Y';\n    if(n.globalPrivacyControl!==true&&n.doNotTrack!=='1'&&!uspDenies&&!priorDenies)return;\n\n    var googletag=w.googletag=w.googletag||{};\n    googletag.cmd=googletag.cmd||[];\n    googletag.cmd.push(function(){\n        var pubads=googletag.pubads&&googletag.pubads();\n        if(pubads&&pubads.setPrivacySettings){\n            pubads.setPrivacySettings({restrictDataProcessing:true,nonPersonalizedAds:true});\n        }\n    });\n\n    var pbjs=w.pbjs=w.pbjs||{};\n    pbjs.que=pbjs.que||[];\n    pbjs.que.push(function(){\n        if(pbjs.setConfig)pbjs.setConfig({\n            deviceAccess:false,\n            allowActivities:{\n                accessDevice:{default:false},\n                accessRequestCredentials:{default:false},\n                enrichEids:{default:false},\n                enrichUfpd:{default:false},\n                syncUser:{default:false},\n                transmitEids:{default:false},\n                transmitPreciseGeo:{default:false},\n                transmitTid:{default:false},\n                transmitUfpd:{default:false}\n            }\n        });\n    });\n})(window,document,navigator);\n","tagPosition":"head","tagPriority":"critical"}],"noscript":[]}

export const appSpaLoaderAttrs = {"id":""}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = true

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = true

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true